import type { EsimCurrency } from "@/lib/types/esim";

/** The three DT One wallets the Global API can bill an eSIM to. */
export const ESIM_CURRENCIES: readonly EsimCurrency[] = [
  "EUR",
  "GBP",
  "CAD",
] as const;

export const DEFAULT_ESIM_CURRENCY: EsimCurrency = "EUR";

/** Remembers the customer's currency choice between visits. */
export const ESIM_CURRENCY_STORAGE_KEY = "esim-currency";

/**
 * Destinations pinned above the search box. DVS speaks ISO-3166 **alpha-3** —
 * unlike the top-up catalogue, which is alpha-2.
 *
 * Country codes only (GD-86): the worldwide (`GXX`) and Europe-wide (`EXX`)
 * pseudo-codes are no longer sold, and the catalogue is filtered to match.
 * France, Spain and Portugal go on the end, and the United Arab Emirates
 * came off.
 */
export const POPULAR_ESIM_DESTINATIONS = [
  "USA",
  "GBR",
  "TUR",
  "THA",
  "MAR",
  "FRA",
  "ESP",
  "PRT",
] as const;

/**
 * Where the store opens. Named rather than taken from the head of the list
 * above, so the order of the pinned chips is free to change without moving
 * every customer to a different country.
 */
export const DEFAULT_ESIM_DESTINATION = "FRA";

/**
 * DT One provisions an eSIM on a callback, so a purchase returns before the
 * profile exists. These bound the wait before we tell the customer to check
 * back from the eSIM list instead of holding the modal open.
 */
export const ORDER_POLL_INTERVAL_MS = 3_000;
export const ORDER_POLL_TIMEOUT_MS = 90_000;
